import React from 'react';
import { mapToCssModules } from '../../utils/className';
export const SmlsPopover = ({ id, content = 'Mensagem de 1 linha', isVisible = true, position, dark = false, }) => {
    return (React.createElement("div", { id: id, className: mapToCssModules([
            'popover',
            position,
            dark ? 'dark' : '',
            isVisible ? 'show' : '',
        ]) },
        React.createElement("span", null, content)));
};
//# sourceMappingURL=index.js.map